import { InformationDetailModel } from "../models/information.model";
import { ConnectorSetting } from "../models/settings.model";

export const campaigns = [
  { label: "Loan Campaign", value: "loan" },
  { label: "Sales Campaign", value: "sales" },
  { label: "Support Campaign", value: "support" },
];

export const getCampaignLabel = (value?: string) => {
  const campaign = campaigns.find((c) => c.value === value);
  return campaign ? campaign.label : value;
};

export const infoOptions_: InformationDetailModel[] = [
  {
    id: "69148524bf58fa0980059d0b",
    propertyKey: "name",
    propertyLabel: "Customer Name",
    propertyDescription: "Customer Full Name",
  },

  {
    id: "69148539bf58fa0980059d0c",
    propertyKey: "phoneNumber",
    propertyLabel: "Customer Phone Number",
    propertyDescription: "Customer Phone Number",
  },
  {
    id: "69148545bf58fa0980059d0d",
    propertyKey: "email",
    propertyLabel: "Customer Email",
    propertyDescription: "Customer Email",
  },
];

export const getInfoLabel = (
  infoOptions: InformationDetailModel[] | null,
  value: string
) => {
  const option = infoOptions?.find((opt) => opt.propertyKey === value);
  return option ? option.propertyLabel : value;
};



export const STATIC_CONNECTORS: ConnectorSetting[] = [
  {
    connectorId: "96617d6c-7c62-453c-a80a-afe20cf53b8b",
    connectorName: "Shopify",
    connections: {},
    isActive: false,
    type: "shopify",
  },
];

export const LANGUAGES = [
  { code: "af", name: "Afrikaans" },
  { code: "sq", name: "Albanian" },
  { code: "ar", name: "Arabic" },
  { code: "az", name: "Azerbaijani" },
  { code: "bn", name: "Bengali" },
  { code: "bg", name: "Bulgarian" },
  { code: "ca", name: "Catalan" },
  { code: "zh_CN", name: "Chinese (Simplified)" },
  { code: "zh_HK", name: "Chinese (Hong Kong)" },
  { code: "zh_TW", name: "Chinese (Traditional / Taiwan)" },
  { code: "hr", name: "Croatian" },
  { code: "cs", name: "Czech" },
  { code: "da", name: "Danish" },
  { code: "nl", name: "Dutch" },
  { code: "en", name: "English" },
  { code: "en_GB", name: "English (UK)" },
  { code: "en_US", name: "English (US)" },
  { code: "et", name: "Estonian" },
  { code: "fil", name: "Filipino" },
  { code: "fi", name: "Finnish" },
  { code: "fr", name: "French" },
  { code: "ka", name: "Georgian" },
  { code: "de", name: "German" },
  { code: "el", name: "Greek" },
  { code: "gu", name: "Gujarati" },
  { code: "ha", name: "Hausa" },
  { code: "he", name: "Hebrew" },
  { code: "hi", name: "Hindi" },
  { code: "hu", name: "Hungarian" },
  { code: "id", name: "Indonesian" },
  { code: "ga", name: "Irish" },
  { code: "it", name: "Italian" },
  { code: "ja", name: "Japanese" },
  { code: "kn", name: "Kannada" },
  { code: "kk", name: "Kazakh" },
  { code: "rw_RW", name: "Kinyarwanda" },
  { code: "ko", name: "Korean" },
  { code: "ky_KG", name: "Kyrgyz" },
  { code: "lo", name: "Lao" },
  { code: "lv", name: "Latvian" },
  { code: "lt", name: "Lithuanian" },
  { code: "mk", name: "Macedonian" },
  { code: "ms", name: "Malay" },
  { code: "ml", name: "Malayalam" },
  { code: "mr", name: "Marathi" },
  { code: "nb", name: "Norwegian" },
  { code: "fa", name: "Persian" },
  { code: "pl", name: "Polish" },
  { code: "pt_BR", name: "Portuguese (Brazil)" },
  { code: "pt_PT", name: "Portuguese (Portugal)" },
  { code: "pa", name: "Punjabi" },
  { code: "ro", name: "Romanian" },
  { code: "ru", name: "Russian" },
  { code: "sr", name: "Serbian" },
  { code: "sk", name: "Slovak" },
  { code: "sl", name: "Slovenian" },
  { code: "es", name: "Spanish" },
  { code: "es_AR", name: "Spanish (Argentina)" },
  { code: "es_MX", name: "Spanish (Mexico)" },
  { code: "es_ES", name: "Spanish (Spain)" },
  { code: "sw", name: "Swahili" },
  { code: "sv", name: "Swedish" },
  { code: "ta", name: "Tamil" },
  { code: "te", name: "Telugu" },
  { code: "th", name: "Thai" },
  { code: "tr", name: "Turkish" },
  { code: "uk", name: "Ukrainian" },
  { code: "ur", name: "Urdu" },
  { code: "uz", name: "Uzbek" },
  { code: "vi", name: "Vietnamese" },
  { code: "zu", name: "Zulu" },
];


export const TEMPLATE_CATEGORIES = [
  {
    value: "MARKETING",
    label: "Marketing",
    description: "Promotions, offers, product updates",
  },
];

export const HEADER_TYPES = [
  { value: "NONE", label: "None" },
  { value: "TEXT", label: "Text" },
];

export const BUTTON_TYPES = [
  { value: "URL", label: "Visit Website", max: 2 },
  { value: "COPY_CODE", label: "Copy Code", max: 1 },
];
